import React from 'react';
import { 
  Typography,
  Box,
  List,
  ListItem, 
  ListItemText,
  ListItemIcon,
  useTheme,
  useMediaQuery
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import successImage from '../../../../assets/images/marketing/achieve-success-ad-picture.png';
import matchesImage from '../../../../assets/images/marketing/matches-ad-picture.png';

const listItems = [
  {
    text: 'View your matches and see how the return on investment looks for you personally.'
  },
  {
    text: 'Get access to our AI guidance counselor and your personal counselors to get a path forward for your education and career.'
  },
  {
    text: 'A checklist of the steps you need to take to get into your dream school and career.'
  },
  {
    text: 'And much more!'
  }
];

export const StudentsContent = ({user}) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery('(min-width:950px)');
  const showMatches = user.investments[0].occupation === "0" || user.investments[0].institution === "0";
  const imageSrc = showMatches ? matchesImage : successImage;

  return (
    <React.Fragment>
      <Box p={2} sx={{ position: 'relative', height: '100%' }}>
        <Box sx={{ position: 'relative', zIndex: 1, height: '100%' }}>
          {user.educator_count > 0 && user.parent_count > 0 ? (
            <Typography variant="h4" component="div" color='primary' sx={{ mb: 1 }}>Sign Up Is Required To Continue!</Typography>
          ) : (
            <>
              {showMatches ? (
                <Typography variant="h4" component="div" color='primary' sx={{ mb: 1 }}>You Have Matches! See Them Today!</Typography>
              ) : (
                <Typography variant="h4" component="div" color='primary' sx={{ mb: 1 }}>Your Roadmap To Success Is Ready!</Typography>
              )}
            </>
          )}
          {user.educator_count > 0 && user.parent_count > 0 ? (
            <Typography variant="h6" component="div" color='secondary'>Sign up to gain access OR if you had access before, check your educators and parents accounts to make sure they are still signed up. You can regain access through them!</Typography>
          ) : (
            <Typography variant="h6" component="div" color='secondary'>Subscribe to your 7 day free trial to get access to everything that Education Advisor has to offer! No commitment, cancel anytime.</Typography>
          )}
          <List sx={{ p: 0 }}>
            {listItems.map((item, index) => (
              <ListItem key={index} sx={{ pl: 0, alignItems: 'flex-start' }}>
                <ListItemIcon sx={{ minWidth: 0, mr: 1, mt: 1 }}>
                  <CheckCircleIcon color="primary" fontSize='small' />
                </ListItemIcon>
                <ListItemText>
                  <Typography component="p" color='secondary'>
                    {item.text}
                  </Typography>
                </ListItemText>
              </ListItem>
            ))}
          </List>
        </Box>
        {isDesktop && (
          <Box sx={{ 
            position: 'absolute',
            bottom: 0,
            right: '80px',
            width: '200px',
            height: 'auto',
            zIndex: 0,
            overflow: 'visible'
          }}>
            <img 
              src={imageSrc} 
              alt="Achieve Success" 
              style={{ 
                width: '100%',
                height: 'auto',
                objectFit: 'contain',
                marginTop: '-220px',
                display: 'block'
              }} 
            />
          </Box>
        )}
      </Box>
    </React.Fragment>
  );
};